import { Tags } from "@/enum/tags";
import { apiSlice } from "../http";
import type {
  IDTEFPaymentResponse,
  IDTEFPaymentParams,
} from "@/@types/dtef-payment";

export const dtefPaymentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDTEFPaymentValues: builder.query<IDTEFPaymentResponse, IDTEFPaymentParams>(
      {
        query: (filters) => {
          const params = new URLSearchParams(
            filters as unknown as Record<string, string>,
          );

          return {
            url: `/dtef/find-value-dtef?${params.toString()}`,
            method: "GET",
          };
        },
        providesTags: [Tags.DTEF],
      },
    ),
  }),
  overrideExisting: false,
});

export const { useGetDTEFPaymentValuesQuery } = dtefPaymentApi;
